import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js"

import "./CalendarWeek.vue?vue&type=style&index=0&id=3b5f4574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5f4574"]])

export default __exports__